import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom"

import PageHeader from "../../components/PageHeader"
import { apiBaseURI } from "../../config"
import { fetchAlumniDetails } from "../../features/young-alumni-award/youngAlumniAwardSlice"
import About from "./About"
import Bio from "./Bio"
import NextAlumni from "./NextAlumni"
import "./young-alumni-page.css"

const YoungAlumniPage = () => {
    let params = useParams()

    let dispatch = useDispatch()

    const { alumniDetails } = useSelector((state) => state.youngAlumniAwardPage)

    useEffect(() => {
        dispatch(fetchAlumniDetails(params.slug))
    }, [dispatch, params.slug])

    return (
        <>
            <PageHeader
                image={`${apiBaseURI}${alumniDetails.cover_image_url}`}
                text={false}
            />
            <About
                name={alumniDetails.name}
                image={`${apiBaseURI}${alumniDetails.image_url}`}
                awardYear={alumniDetails.award_year}
                degreeYear={alumniDetails.degree_year}
            />
            <Bio about={alumniDetails.description} />
            <NextAlumni
                next={alumniDetails.next}
                prev={alumniDetails.previous}
            />
        </>
    )
}

export default YoungAlumniPage
